import { useState, useEffect } from "react";
import { format } from "multi-date";
import { axiosInstance, axiosInstance2 } from "helpers/axiosInstance";
import { useQueryClient } from "react-query";

export const useListingCalculations = ({
	numRooms,
	numChildren,
	numAdults,
	numInfants,
	dates,
	id,
	type = "",
	numPet,
}: any) => {
	const [calculations, setCalculations] = useState({});
	const [calLoading, setCalLoading] = useState(false);
	const [calError, setCalError] = useState(false);

	const queryClient = useQueryClient();

	useEffect(() => {
		if (!dates.checkin || !dates.checkout) {
			setCalLoading(false);
			setCalError(false);
			setCalculations({});
			return;
		}
		setCalLoading(true);
		setCalError(false);

		// calculation request
		axiosInstance2({
			method: "POST",
			url: "/manageBookings/recal",
			headers: {
				Authorization: localStorage.getItem("token")
					? `Bearer ${localStorage.getItem("token")}`
					: "",
			},
			data: {
				LISTING_ID: id,
				FROM_DATE: format(dates.checkin, "YYYY-MM-DD"),
				TO_DATE: format(dates.checkout, "YYYY-MM-DD"),
				NUM_ROOMS: numRooms,
				NUM_CHILD: numChildren,
				NUM_INFANTS: numInfants,
				NUM_ADULTS: numAdults,
				NUM_PETS: numPet,
				TYPE: type,
			},
		})
			.then((res) => {
				setCalculations(res.data.data);
				setCalLoading(false);
				setCalError(false);
				// unlockDisData
				queryClient.invalidateQueries("unlockDisData");
			})
			.catch((error) => {
				let temp = error.response.data.error;
				if (typeof error.response.data.error === "object")
					temp = Object.values(error.response.data.error)[0];
				setCalLoading(false);
				setCalError(temp);
			});
	}, [dates, id, numRooms, numAdults, numChildren, numInfants, numPet]);

	return { calculations, calLoading, calError };
};
